document.addEventListener('click', function (e) {
  if (e.target.matches('.discount_code[data-copy]')) {
    const textToCopy = e.target.textContent.trim()

    if (textToCopy) {
      navigator.clipboard.writeText(textToCopy).then(function () {
        const originalText = e.target.textContent
        e.target.textContent = 'Copied!'
        setTimeout(() => {
          e.target.textContent = originalText
        }, 1500)
      }).catch(function (err) {
        console.error('Failed to copy: ', err)
      })
    }
  }
})
